import * as React from "react"

interface GapProps {
  size: number
}

export class Gap extends React.Component<GapProps> {
  render() {
    return (
      <div
        style={{
          height: this.props.size,
          width: this.props.size,
        }}
      />
    )
  }
}
